<script setup lang="ts">
const settingsStore = useSettingsStore();
const { _settings: settings } = storeToRefs(settingsStore);
</script>

<template>
  <div
      class="announcement"
      :style="{
      '--bg': settings?.announcement_bg,
      '--text': settings?.announcement_color
    }"
  >
    <div :class="{ 'announcement-inner': settings?.announcement_animation }">
      <span v-html="settings?.announcement_text"></span>
    </div>
  </div>
</template>

<style scoped>
.announcement {
  background: var(--bg);
  color: var(--text);
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  font-weight: var(--fw-bold);
  font-size: var(--fs--1);
  text-align: center;
  padding: 4px 0;
}

.announcement-inner {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 18s linear infinite;
  color: var(--text);

}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>